<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Madrid Río</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Por muy urbanitas que seamos, a veces necesitamos desconectar de la jungla de asfalto y conectar con
              nosotros mismos. Calzarnos las zapatillas o subirnos a la bici, ponernos nuestra música favorita y
              evadirnos de todo. ¿A dónde vas cuando quieres sentir la tierra bajo tus zancadas o dar un largo paseo en
              bicicleta? Nosotros lo tenemos claro:
              <strong
                >¡la Sierra Norte de Madrid es el lugar idóneo para despejar nuestra mente y activar nuestro
                cuerpo!</strong
              >
            </p>
          </div>
          <div class="col-12 mt-4">
            <img src="/img/icons/aventureros.svg" alt="Planes especiales para aventureros" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para aventureros</span
            >
            <div class="w100 my-5"></div>
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Lugares tranquilos para personas inquietas</h2>
            <p class="subtitular z-index-up">
              Las montañas y los embalses de la Sierra Norte de Madrid ofrecen
              <strong>un sinfín de posibilidades a los amantes de las emociones fuertes,</strong> con algunos parajes
              que supondrán un desafío para tus nervios.
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta4/raquetas.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Raquetas de nieve</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Te gusta la nieve? Te proponemos
                      <a
                        href="https://www.sierranortemadrid.org/deportes-de-nieve/"
                        target="_blank"
                        alt="Más inforrmación sobre la actividad"
                        >una actividad sencilla,</a
                      >
                      ¡pero más exigente de lo que podrías pensar! Aunque no tienes que preocuparte: si te gusta hacer
                      deporte en la naturaleza pero sin realizar un gran esfuerzo físico,
                      <strong>hay rutas para todo tipo de niveles y edades.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Qué debemos llevar de casa: ropa deportiva cómoda y de abrigo, protector solar, gafas de sol,
                      guantes, calzado de montaña o calzado deportivo impermeable. También es recomendable llevar
                      calzado de repuesto. Y, dependiendo de la ruta, llevar agua y comida.
                    </span>
                  </li>
                  <li>
                    <span>
                      Qué equipo puede alquilarse: raquetas y bastones.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="Variable" />
                  <icon-invierno />
                  <icon-familias />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Raquetas de nieve</h3>
                <p>
                  El manto de nieve sobre la Sierra Norte de Madrid deja estampas preciosas…¡e ideales para practicar
                  ejercicio!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="Variable" />
                  <icon-invierno />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta4/puenting.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>

              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Puenting</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong>Máxima emoción, ¡con la máxima seguridad!</strong>
                      <a
                        href="https://www.sierranortemadrid.org/planes/1-2-3-salto"
                        target="_blank"
                        alt="Más información sobre la actividad de puenting"
                        >Esta actividad</a
                      >
                      cuenta con diferentes packs de salto: salto clásico, salto plus extrem y salto con fotos y vídeo.
                    </span>
                  </li>
                  <li>
                    <span>
                      ¿Qué debes llevar? Ropa cómoda, agua y algo de comida para reponer energía después del salto.
                    </span>
                  </li>
                  <li>
                    <span>
                      Esta actividad está sujeta a la disponibilidad de las empresas que la realizan.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Puenting</h3>
                <p>Para amantes de las emociones fuertes: ¡máxima emoción, con la máxima seguridad!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta4/parapente.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Vuelo en parapente</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/multiaventura/"
                        target="_blank"
                        alt="Más información sobre la actividad de vuelo en parapente"
                        >¿Te gustaría ver el paisaje de Madrid desde las alturas?</a
                      >
                      Tienes <strong>distintas opciones en función de tu experiencia de vuelo:</strong> vuelos biplaza
                      (acompañados de un instructor), curso de iniciación, curso avanzado y curso de perfeccionamiento.
                    </span>
                  </li>
                  <li>
                    <span>
                      Es aconsejable llevar ropa cómoda, agua y algo de comida, para reponer energías después de la
                      actividad.
                    </span>
                  </li>
                  <li>
                    <span>
                      La actividad <strong>puede realizarse prácticamente los 365 días del año,</strong> aunque nosotros
                      recomendamos hacerla en primavera y verano.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-8h" />
                  <icon-parejas />
                  <icon-influencers />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Vuelo en parapente</h3>
                <p>¡Siéntete libre como el viento mientras disfrutas de paisajes espectaculares a vista de pájaro!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-8h" />
                  <icon-parejas />
                  <icon-influencers />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta4/escuela-escalada.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Escalada</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong>¿Sabías que Patones es un referente para la escalada en Madrid?</strong> Se trata de
                      <a
                        href="https://www.sierranortemadrid.org/escalada"
                        target="_blank"
                        alt="Más información sobre escalada en Sierra Norte"
                        >una zona de escalada</a
                      >
                      deportiva, de roca caliza de buena calidad.
                    </span>
                  </li>
                  <li>
                    <span>
                      Es posible escalar durante todo el año, salvo la zona media y alta, que permanecen cerradas por
                      nidificación del 15 de enero al 15 de junio.
                      <strong>En verano se recomienda escalar por la mañana,</strong> para evitar el sol directo.
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: la longitud de las vías suele ser de unos 20-25 metros hasta 40 metros. Por
                      ello, no está de más contar con una cuerda de 60/70 metros.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-foodies />
                  <icon-todas-estaciones />
                  <icon-influencers />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Escalada</h3>

                <p>Cuerda, una pared prodigiosa y todo un desafío por delante. ¡Practica la escalada en Patones!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-foodies />
                  <icon-todas-estaciones />
                  <icon-influencers />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta4/deportes-acuaticos.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Deportes acuáticos</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¡En Madrid también disfrutamos de los
                      <a
                        href="https://www.sierranortemadrid.org/acuaticas/"
                        target="_blank"
                        alt="Información sobre deportes acuáticos en Sierra Norte"
                        >deportes acuáticos!</a
                      >
                      <strong
                        >Puedes realizarlos en la Estación Náutica de Interior de Cervera de Buitrago y los embalses del
                        Atazar, Pinilla, Riosequillo y Puentes Viejas.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      Es posible realizar tres actividades distintas: bautismo náutico, cursos de iniciación, y cursos
                      de perfeccionamiento. También es posible alquilar barcos
                    </span>
                  </li>
                  <li>
                    <span> Para la realización de cursos es necesario contar con un mínimo de 4 personas. </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: es recomendable llevar toalla, ropa de baño, protección solar, gorra, gafas de
                      sol, agua y comida.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3-8h" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-familias />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Deportes acuáticos</h3>

                <p>
                  En Madrid somos “gatos”, pero también disfrutamos de deportes acuáticos como la vela o el paddle surf
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3-8h" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta4/bici-electrica.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Bici de montaña eléctrica</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong
                        >Con las bicis de montaña eléctricas reducirás el esfuerzo y potenciarás el disfrute del
                        paisaje.</strong
                      >
                      ¡Descubre rutas por tu cuenta o ve en grupo con un guía! Si os interesa esta última opción,
                      tendréis que ser al menos dos personas.
                    </span>
                  </li>
                  <li>
                    <span> Los meses de invierno son menos aconsejables, debido a las lluvias y la nieve. </span>
                  </li>
                  <li>
                    <span>
                      Consejo adicional: recomendamos llevar ropa cómoda, calzado deportivo, protección solar y agua.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-4h" />
                  <icon-parejas />
                  <icon-familias />

                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Bici de montaña eléctrica</h3>
                <p>Realiza una ruta en bicicleta por parajes espectaculares, ¡sin desfallecer en el intento!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-4h" />
                  <icon-parejas />
                  <icon-familias />

                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Raquetas de nieve">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¿Te gusta la nieve? Te proponemos
                <a
                  href="https://www.sierranortemadrid.org/deportes-de-nieve/"
                  target="_blank"
                  alt="Más inforrmación sobre la actividad"
                  >una actividad sencilla,</a
                >
                ¡pero más exigente de lo que podrías pensar! Aunque no tienes que preocuparte: si te gusta hacer deporte
                en la naturaleza pero sin realizar un gran esfuerzo físico,
                <strong>hay rutas para todo tipo de niveles y edades.</strong>
              </span>
            </li>
            <li>
              <span>
                Qué debemos llevar de casa: ropa deportiva cómoda y de abrigo, protector solar, gafas de sol, guantes,
                calzado de montaña o calzado deportivo impermeable. También es recomendable llevar calzado de repuesto.
                Y, dependiendo de la ruta, llevar agua y comida.
              </span>
            </li>
            <li>
              <span>
                Qué equipo puede alquilarse: raquetas y bastones.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Puenting">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/planes/1-2-3-salto"
                  target="_blank"
                  alt="Más información sobre la actividad de puenting"
                  >Esta actividad</a
                >
                cuenta con diferentes packs de salto: salto clásico, salto plus extrem y salto con fotos y vídeo.
              </span>
            </li>
            <li>
              <span>
                ¿Qué debes llevar? Ropa cómoda, agua y algo de comida para reponer energía después del salto.
              </span>
            </li>
            <li>
              <span>
                Esta actividad está sujeta a la disponibilidad de las empresas que la realizan.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Vuelo en parapente">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/multiaventura/"
                  target="_blank"
                  alt="Más información sobre la actividad de vuelo en parapente"
                  >¿Te gustaría ver el paisaje de Madrid desde las alturas?</a
                >
                Tienes <strong>distintas opciones en función de tu experiencia de vuelo:</strong> vuelos biplaza
                (acompañados de un instructor), curso de iniciación, curso avanzado y curso de perfeccionamiento.
              </span>
            </li>
            <li>
              <span>
                Es aconsejable llevar ropa cómoda, agua y algo de comida, para reponer energías después de la actividad.
              </span>
            </li>
            <li>
              <span>
                La actividad <strong>puede realizarse prácticamente los 365 días del año,</strong> aunque nosotros
                recomendamos hacerla en primavera y verano.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Escalada">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong>¿Sabías que Patones es un referente para la escalada en Madrid?</strong> Se trata de
                <a
                  href="https://www.sierranortemadrid.org/escalada"
                  target="_blank"
                  alt="Más información sobre escalada en Sierra Norte"
                  >una zona de escalada</a
                >
                deportiva, de roca caliza de buena calidad.
              </span>
            </li>
            <li>
              <span>
                Es posible escalar durante todo el año, salvo la zona media y alta, que permanecen cerradas por
                nidificación del 15 de enero al 15 de junio.
                <strong>En verano se recomienda escalar por la mañana,</strong> para evitar el sol directo.
              </span>
            </li>
            <li>
              <span>
                Consejo adicional: la longitud de las vías suele ser de unos 20-25 metros hasta 40 metros. Por ello, no
                está de más contar con una cuerda de 60/70 metros.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Deportes acuáticos">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¡En Madrid también disfrutamos de los
                <a
                  href="https://www.sierranortemadrid.org/acuaticas/"
                  target="_blank"
                  alt="Información sobre deportes acuáticos en Sierra Norte"
                  >deportes acuáticos!</a
                >
                <strong
                  >Puedes realizarlos en la Estación Náutica de Interior de Cervera de Buitrago y los embalses del
                  Atazar, Pinilla, Riosequillo y Puentes Viejas.</strong
                >
              </span>
            </li>
            <li>
              <span>
                Es posible realizar tres actividades distintas: bautismo náutico, cursos de iniciación, y cursos de
                perfeccionamiento. También es posible alquilar barcos
              </span>
            </li>
            <li>
              <span> Para la realización de cursos es necesario contar con un mínimo de 4 personas. </span>
            </li>
            <li>
              <span>
                Consejo adicional: es recomendable llevar toalla, ropa de baño, protección solar, gorra, gafas de sol,
                agua y comida.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal id="modal6" centered scrollable size="lg" hide-footer title="Bici de montaña eléctrica">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong
                  >Con las bicis de montaña eléctricas reducirás el esfuerzo y potenciarás el disfrute del
                  paisaje.</strong
                >
                ¡Descubre rutas por tu cuenta o ve en grupo con un guía! Si os interesa esta última opción, tendréis que
                ser al menos dos personas.
              </span>
            </li>
            <li>
              <span> Los meses de invierno son menos aconsejables, debido a las lluvias y la nieve. </span>
            </li>
            <li>
              <span>
                Consejo adicional: recomendamos llevar ropa cómoda, calzado deportivo, protección solar y agua.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    // IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    IconInvierno: () => import('../../components/iconos/IconInvierno'),
    // IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones')
    // IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-50%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '60%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
